import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, AuthorityDTO} from '@sollapay/types';

export const authoritiesApi = {
  fetchAuthorities: (client: HttpClient): Promise<ApiResponse<AuthorityDTO[]>> =>
    client.get<ApiResponse<AuthorityDTO[]>>('/authorities')
};
